/**
 * api接口统一管理
 */
import { get, post, postForm } from "./https";

/* 获取国家列表  GET*/
export const getCountry = (params) => get("/orbitdata/getCountryList", params);
